export default "__VITE_ASSET__bftkh5yP__"